import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';

import { DateHelper } from '../../helpers/date-helper';
import { FormHelper } from '../../helpers/form-helper';
import { Meetup } from '../../models/meetup';
import { MeetupService } from '../../services/meetup.service';

@Component({
	selector: 'app-update-meetup',
	templateUrl: './update-meetup.component.html',
	styleUrls: ['./update-meetup.component.scss']
})
export class UpdateMeetupComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	private key: string;

	constructor(private dialogRef: MdDialogRef<UpdateMeetupComponent>,
		private formBuilder: FormBuilder,
		private meetupService: MeetupService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();
	}

	ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			description: new FormControl('', Validators.required),
			number: new FormControl('', Validators.required),
			startsAt: new FormControl('', Validators.required),
			endsAt: new FormControl('', Validators.required),
			maxCouples: new FormControl('', Validators.required),
			coupleCost: new FormControl('', Validators.required)
		});
	}

	public updateForm(meetup: Meetup): void {
		this.key = meetup.$key;

		this.form.controls['description'].setValue(meetup.description);
		this.form.controls['number'].setValue(meetup.number);

		const s: Date = new Date(meetup.startsAt);
		this.form.controls['startsAt'].setValue(DateHelper.toYYYYMMDDString(s));

		const e: Date = new Date(meetup.endsAt);
		this.form.controls['endsAt'].setValue(DateHelper.toYYYYMMDDString(e));

		this.form.controls['maxCouples'].setValue(meetup.maxCouples);
		this.form.controls['coupleCost'].setValue(meetup.coupleCost);
	}

	public async submitForm(): Promise<any> {
		let meetup: Meetup = this.form.value;

		meetup.startsAt = new Date(this.form.controls['startsAt'].value + 'T10:20:30Z').getTime();
		meetup.endsAt = new Date(this.form.controls['endsAt'].value + 'T10:20:30Z').getTime();

		await this.meetupService.updateMeetup(this.key, meetup);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/update-meetup/update-meetup.component.ts